import { render } from "./RecordLink.vue?vue&type=template&id=e8b67446"
import script from "./RecordLink.vue?vue&type=script&lang=js"
export * from "./RecordLink.vue?vue&type=script&lang=js"

import "./RecordLink.vue?vue&type=style&index=0&id=e8b67446&lang=css"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__